import { Swiper, Navigation, Pagination, Thumbs, Autoplay } from "swiper";
let spaceBetweenResp = 20;
let slidesPerViewResp = 3;
if (window.innerWidth >= 992) {
    spaceBetweenResp = 30;
    slidesPerViewResp = 4;
}
if (window.innerWidth >= 1200) {
    spaceBetweenResp = 40;
    slidesPerViewResp = 6;
}

const logoSwiper = new Swiper('.logo-swiper', {
    modules: [Navigation, Pagination, Thumbs, Autoplay],
    speed: 2000,
    loop: true,
    autoplay: {
        delay: 1000,
        disableOnInteraction: false,
    },
    spaceBetween: spaceBetweenResp,
    slidesPerView: slidesPerViewResp,
    freeMode: true,
    pauseOnMouseEnter: true,
    watchSlidesProgress: true, 
});